module.exports = __webpack_public_path__ + "static/media/hundzi.451e89a0.svg";